import { render, staticRenderFns } from "./VendorSideSummary.vue?vue&type=template&id=30c61a98&"
import script from "./VendorSideSummary.vue?vue&type=script&lang=js&"
export * from "./VendorSideSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports